import * as React from 'react';
import { GridColumn } from '@telia-front/grid';
export default class OfferCounterItem extends React.Component {
    constructor() {
        super(...arguments);
        this.getChild = (children) => React.createElement("div", { className: "offer-counter__figure-inner" }, children);
    }
    BEM() {
        const classArray = ['offer-counter__item'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement(GridColumn, { width: this.props.width, className: this.BEM() },
            React.createElement("div", { className: "offer-counter__figure" },
                this.props.children && this.getChild(this.props.children),
                React.createElement("div", { className: "offer-counter__table" }))));
    }
}
